import { RESET_PASSWORD } from "../actions/reset-password-action";
import { ApiRequestState } from "../../types/state-management";

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const resetPasswordReducer = (
  state = initialState,
  action: any
): ApiRequestState => {
  switch (action.type) {
    case RESET_PASSWORD.REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case RESET_PASSWORD.SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case RESET_PASSWORD.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export { resetPasswordReducer };
